type ContactSectionProps = {
  email: string;
};

const ContactSection = ({ email }: ContactSectionProps) => {
  return (
    <section id="contact" className="section contact">
      <div className="section-header">
        <p className="eyebrow">Contact</p>
        <h2>Let&apos;s build something impactful</h2>
        <p className="lede">Open to internships, research projects, and collaborative builds. Project code available upon request.</p>
      </div>
      <div className="contact-card">
        <div>
          <p className="meta">Email</p>
          <a className="contact-link" href={`mailto:${email}`}>
            {email}
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
